/**
 * ============================================================================
 * BAMBOOVE — "BAY VÀO GIỎ"  ·  phiên 76c · 17/10/2026
 * ----------------------------------------------------------------------------
 * HỌC TỪ HORIZON 4.3 (`assets/fly-to-cart.js`):
 *   Bấm thêm hàng ⇒ tạo 1 phần tử ẢNH SẢN PHẨM bay theo ĐƯỜNG CONG tới NÚT GIỎ
 *   ở header (đích = `.header-actions__cart-icon` — class Horizon giữ nguyên trong
 *   theme mình), rồi tự xoá sau khi bay xong. Bố cục bay nằm ở CSS
 *   `assets/bamboove-bay-gio.css` (3 khung hình travel-x / travel-y / thu nhỏ).
 *
 * Dùng chung cho MỌI đường thêm hàng:
 *   · nút mua ở PDP        → loại "main"
 *   · thẻ sản phẩm         → loại "quick"  (bestsellers/shop-by-style/gợi ý)
 *   · thanh mua dính đáy   → loại "sticky"
 *   · (thêm từ TRONG NGĂN KÉO giỏ thì KHÔNG bay — giống Horizon: giỏ đang che nút giỏ)
 *
 * Gọi: window.bambooveBayGio({ nguon, anh, loai, layCoNguon })
 *   nguon      : phần tử xuất phát (nút bấm / ảnh nhỏ thanh dính đáy)
 *   anh        : URL ảnh sản phẩm (để trống ⇒ dùng ô xanh Bamboove)
 *   loai       : 'main' | 'quick' | 'sticky'
 *   layCoNguon : true ⇒ lấy ĐÚNG cỡ phần tử nguồn (kiểu thanh dính đáy — y Horizon)
 * Tôn trọng `prefers-reduced-motion` (không bay) — y Horizon.
 * File RIÊNG của khối này — không sửa file nào khác của theme.
 * ============================================================================
 */
(function () {
  'use strict';

  var DICH_MAC_DINH = '.header-actions__cart-icon';

  function timDich() {
    return document.querySelector(DICH_MAC_DINH) || document.querySelector('[ref="cartBubble"]');
  }

  function bayGio(o) {
    try {
      o = o || {};
      var nguon = o.nguon;
      if (!nguon || typeof nguon.getBoundingClientRect !== 'function') return false;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

      var dich = timDich();
      if (!dich) return false;

      var rN = nguon.getBoundingClientRect();
      var rD = dich.getBoundingClientRect();
      if ((!rN.width && !rN.height) || (!rD.width && !rD.height)) return false; /* bị ẩn ⇒ thôi */

      var loai = o.loai === 'sticky' ? 'sticky' : (o.loai === 'quick' ? 'quick' : 'main');

      var el = document.createElement('div');
      el.className = 'bb-bay bb-bay--' + loai;
      el.setAttribute('aria-hidden', 'true');
      if (o.anh) el.style.backgroundImage = 'url("' + String(o.anh).replace(/"/g, '%22') + '")';
      if (o.layCoNguon) {
        el.style.setProperty('--bb-bay-rong', Math.round(rN.width) + 'px');
        el.style.setProperty('--bb-bay-cao', Math.round(rN.height) + 'px');
      }
      /* kiểu "main": hiện DẦN ngay sau khi rời nút (y Horizon `--start-opacity: 0`) */
      if (loai === 'main') el.style.setProperty('--bb-bay-op0', '0');

      var x0 = rN.left + rN.width / 2;
      var y0 = rN.top + rN.height / 2;
      var x1 = rD.left + rD.width / 2;
      var y1 = rD.top + rD.height / 2;
      el.style.setProperty('--bb-bay-x0', x0 + 'px');
      el.style.setProperty('--bb-bay-y0', y0 + 'px');
      el.style.setProperty('--bb-bay-tx', (x1 - x0) + 'px');
      el.style.setProperty('--bb-bay-ty', (y1 - y0) + 'px');

      /* biến đã đặt TRƯỚC khi gắn vào DOM ⇒ khung hình chạy đúng ngay nhịp đầu */
      document.body.appendChild(el);

      el.addEventListener('animationend', function (ev) {
        if (ev.animationName && ev.animationName !== 'bb-bay-thu') return; /* chờ khung CUỐI */
        if (el.parentNode) el.remove();
      });
      /* lưới an toàn: dù hoạt ảnh không chạy (trình duyệt cũ) thì cũng dọn */
      window.setTimeout(function () { if (el.parentNode) el.remove(); }, 1300);
      return true;
    } catch (e) {
      return false;
    }
  }

  window.bambooveBayGio = bayGio;
})();
